<div class="route-input">
  <app-google-place-search [title]="'From'" useLocalStorage=true showCurrentLocation=false tabindex="0"
    [placeHolder]="this.fromLocationModel.errorMessage" [locationModel]="this.fromLocationModel"  
    (onSubmit)="submitSearch()" (onGotFocus)="reset()" [updateLocationName]="this.fromLocationModel.Name" >
  </app-google-place-search>

  <app-google-place-search [title]="'To'" useLocalStorage=true showCurrentLocation=false tabindex="0"
    [placeHolder]="this.toLocationModel.errorMessage" [locationModel]="this.toLocationModel" 
    (onSubmit)="submitSearch()" (onGotFocus)="reset()" [updateLocationName]="this.toLocationModel.Name" >
  </app-google-place-search>
</div>

<button type="button" class="btn switch" aaNoDblClick (click)="reverseRoute()"></button>
<span class='invalid-route-error'>
  {{locationManager.generalErrorMessage}}
</span>
